import React from 'react';
import {
  shape, node,
} from 'prop-types';
import ConsultSummary from './ConsultSummary';

const ConsultSummaryWrapper = (props) => {
  const { contextMenu, children, ...rest } = props;
  return (
    <ConsultSummary {...rest} contextMenu={contextMenu} />
  );
};


ConsultSummaryWrapper.propTypes = {
  contextMenu: shape({}).isRequired,
  children: node,
};

ConsultSummaryWrapper.defaultProps = {
  children: null,
};


export default ConsultSummaryWrapper;
